const LowerFooter = () => (
  <div className="ct-trust-markers large-12 columns pt20 pb20 footer-pad pl0">
    <div className="info-text large-6 small-12 columns ct-font-grey pl0">
      ClearTax is a product by Defmacro Software Pvt. Ltd.
      <div className="trust-links">
        <a className="link" target="_blank" href="/Meta/Privacy">
          Privacy Policy
        </a>
        <a className="link" target="_blank" href="/Meta/Terms">
          Terms of Use
        </a>
      </div>
    </div>
    <div className="trust-markers large-6 small-12 columns ct-font-grey">
      <div className="marker iso large-6 small-12 columns">
        <span className="logo">
          <img src="https://assets1.cleartax-cdn.com/common/images/iso-logo.png" />
        </span>
        ISO 27001
        <br />
        Data Center
      </div>
      <div className="marker security large-6 small-12 columns ct-font-grey">
        <span className="logo">
          <img src="https://assets1.cleartax-cdn.com/common/images/ssl.png" />
        </span>
        SSL Certified Site
        <br />
        128-bit encryption
      </div>
      <img
        src="https://assets1.cleartax-cdn.com/ct-frontend/images/delete.svg"
        style={{ display: 'none' }}
      />
      <img
        src="https://assets1.cleartax-cdn.com/ct-frontend/images/addBack.svg"
        style={{ display: 'none' }}
      />
    </div>
    <style jsx>{`
      .trust-links a:first-child {
        margin-right: 15px;
      }
      .margin-auto {
        border-top: 1px solid #ebebeb;
        color: #999;
        -webkit-font-smoothing: antialiased;
      }
      .marker {
        display: inline-block;
        width: 48%;
        height: 40px;
        box-sizing: border-box;
        position: relative;
        padding-left: 50px;
      }

      .logo {
        width: 40px;
        height: 40px;
        display: inline-block;
        padding-right: 10px;
        position: absolute;
        top: 0;
        left: 0;
        text-align: right;
      }

      @media screen and (max-width: 768px) {
        .marker {
          width: 100%;
          margin-top: 15px;
        }
      }
    `}</style>
  </div>
);

export default LowerFooter;



// WEBPACK FOOTER //
// ./components/footer/lowerFooter.tsx